import { HttpErrorResponse } from '@angular/common/http';
import firebase from 'firebase';

export interface ExtraApiErrorInfo {
	[k: string]: any;
	planId?: string;
	planName?: string;
	lastAppointment?: string;
	nextAvailable?: string;
	type?: string;
	data?: any;
}

export interface ApiError {
	statusCode: number;
	error?: string;
	message: string;
	messageI18n: string;
	data?: ExtraApiErrorInfo;
}

export class ApiErrorResponse extends HttpErrorResponse {
	readonly error: ApiError | firebase.auth.Error | null;

	isFirebaseError(): this is firebase.auth.Error {
		return (this.error as firebase.auth.Error).code !== undefined;
	}

	isApiError(): this is ApiError {
		return (this.error as ApiError).messageI18n !== undefined;
	}
}
